import { createElement } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { APP_ROUTES } from './routeConfig';
import { protectedRoute, publicRoute } from './routeHelpers';

export const router = createBrowserRouter([
  {
    element: <MainLayout />,
    children: [
      ...APP_ROUTES.map(({ path, page, permission, public: isPublic }) => ({
        path,
        element: isPublic
          ? publicRoute(createElement(page))
          : protectedRoute(createElement(page), permission),
      })),
      { path: '/items', element: <Navigate to="/" replace /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
